import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import TermsOfService from "@/components/TermsOfService";
import CookiePolicy from "@/components/CookiePolicy";
import StatsPage from "@/components/StatsPage";
import { CookieConsent } from "@/components/CookieConsent";
import { useLenis, scrollToId } from "@/hooks/useLenis";
import { FloatingGiftPopup } from "@/components/FloatingGiftPopup";
import { NoticePopup } from "@/components/NoticePopup";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { GiftCardSection } from "@/components/GiftCardSection";
import { GrantSection } from "@/components/GrantSection";
import { ServicesSection } from "@/components/ServicesSection";
import { BookingQuoteForm } from "@/components/BookingQuoteForm";
import { FAQSection } from "@/components/FAQSection";
import { ContactAndFooter } from "@/components/ContactAndFooter";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (localStorage.getItem("sf_consent") === "all") {
      axios.post(`${API}/analytics/pageview`, { path: location.pathname }).catch(() => {});
    }
  }, [location.pathname]);
  return null;
};

const Home = () => {
  useLenis();
  useEffect(() => {
    if (window.location.hash) {
      const t = setTimeout(() => scrollToId(window.location.hash), 700);
      return () => clearTimeout(t);
    }
  }, []);
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <GiftCardSection />
        <GrantSection />
        <ServicesSection />
        <BookingQuoteForm />
        <FAQSection />
        <ContactAndFooter />
      </main>
      <FloatingGiftPopup />
      <NoticePopup />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <PageTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/integritetspolicy" element={<PrivacyPolicy />} />
        <Route path="/anvandarvillkor" element={<TermsOfService />} />
        <Route path="/cookiepolicy" element={<CookiePolicy />} />
        <Route path="/statistik" element={<StatsPage />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <CookieConsent />
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
